import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TextareaQuestion } from 'core/components/forms/question-textarea';
import { ToastService } from 'core/services/toast.service';
import { MarsMessagesService } from './mars-messages.service';
import { MarsMessagesListService } from './mars-messages-list.service';
import { ModalComponent } from 'core/components/modal/modal.component';

@Component({
  selector: 'lms-mars-messages',
  templateUrl: './mars-messages.component.html',
  styleUrls: ['./mars-messages.component.scss'],
  providers: [MarsMessagesService, MarsMessagesListService]
})
export class MarsMessagesComponent implements OnInit {
  @Input() listId: string;
  @Input() group: any;
  @ViewChild('sendMessageModal', { static: false }) public sendMessageModal: ModalComponent;

  public toolbarConfig: any;
  public dataSource: any;

  public messageTextArea: TextareaQuestion = new TextareaQuestion({ key: 'message' });

  constructor(
    public messagesService: MarsMessagesService,
    public messagesListService: MarsMessagesListService,
    public toastService: ToastService
  ) {}

  async ngOnInit() {
    const options = {
      filters: {
        groupId: this.group.id,
        type: 'RRHH_MESSAGE'
      }
    };
    this.dataSource = await this.messagesListService.getDatasource(this.listId, options);

    this.toolbarConfig = {
      list: {
        listId: this.listId,
        columnChooser: false,
        download: false,
        filterRow: false,
        hidePrint: true,
        skeletor: true
      }
    };
  }

  openSendMessageModal() {
    this.messageTextArea = new TextareaQuestion({ key: 'message' });
    this.sendMessageModal.open();
  }

  sendMessage(data) {
    const payload = {
      groupId: this.group.id,
      ...data
    };

    this.sendMessageModal.close();
    this.messagesService
      .create(payload)
      .then(() => {
        this.dataSource.refreshData({});
        this.toastService.showOk('', '', '');
      })
      .catch((error) => {
        this.toastService.showError(error, '', '');
      });
  }
}
